module.exports = require("proptypes");


//////////////////
// WEBPACK FOOTER
// external "proptypes"
// module id = 33
// module chunks = 0